import { type Styles } from '@adornis/ass/style';
import '@adornis/chemistry/elements/components/x-flex';
import { fontReset } from '@adornis/fonts/font-resets';
import { XH1, XH2, XH3, XH4, XText } from '@adornis/fonts/fonts';
import { customElement } from 'lit/decorators.js';

export const FPSFontFamily = 'Euclid Circular A';

@customElement('fps-h1')
export class FPSH1 extends XH1 {
  override styles(): Styles[] {
    return [...super.styles(), fontReset(FPSFontFamily, 2.4, 700, 1.6, this.baseFontSize)];
  }
}

@customElement('fps-h2')
export class FPSH2 extends XH2 {
  override styles(): Styles[] {
    return [...super.styles(), fontReset(FPSFontFamily, 1.8, 700, 1.6, this.baseFontSize)];
  }
}
/**
 * @element fps-text>
 */

@customElement('fps-h3')
export class FPSH3 extends XH3 {
  override styles(): Styles[] {
    return [...super.styles(), fontReset(FPSFontFamily, 1.6, 700, 1.4, this.baseFontSize)];
  }
}

@customElement('fps-h4')
export class FPSH4 extends XH4 {
  override styles(): Styles[] {
    return [...super.styles(), fontReset(FPSFontFamily, 1.4, 700, 1.6, this.baseFontSize)];
  }
}

@customElement('fps-text')
export class FpsText extends XText {
  override styles(): Styles[] {
    return [...super.styles(), fontReset(FPSFontFamily, 1, 400, 1.6, this.baseFontSize)];
  }
}

@customElement('fps-subtext')
export class FpsSubText extends XText {
  override styles(): Styles[] {
    return [...super.styles(), fontReset(FPSFontFamily, 0.8, 400, 1.6, this.baseFontSize)];
  }
}
